module.exports = __webpack_public_path__ + "img/info.026c66ca.svg";